import { MovingBanner } from '../helpers/moving-banner'

const footerBanner = new MovingBanner('.logo-slider-block')
footerBanner.play()
